var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM12.5981 8.49986C12.0241 7.50566 9.02285 5.85497 7.66659 5.14526C7.35019 4.97969 6.97741 5.19492 6.96259 5.55171C6.89909 7.08112 6.82799 10.5057 7.40199 11.4999C7.976 12.4941 10.9773 14.1448 12.3335 14.8545C12.6499 15.02 13.0227 14.8048 13.0375 14.448C13.101 12.9186 13.1721 9.49407 12.5981 8.49986Z",
    fill: "#FF2241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2d6a8d6b09a77f8e918e9953c6231f4c.svg";
export { ForwardRef as ReactComponent };